import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "../store";
import viMessage from "../locale/language/vi.json";
import enMessage from "../locale/language/en.json";
import {getLang} from "@/helpers/helpers";

Vue.use(VueI18n);

let locale = getLang();
if (locale.length > 2) {
    locale = locale.substring(0, 2);
}

document.body.classList.add(`lang-${ locale }`);

const messages = {
    en: enMessage,
    vi: viMessage,
};

const i18n = new VueI18n({
    locale: locale,
    messages,
    fallbackLocale: locale
});
export default i18n;
